module.exports = __webpack_public_path__ + "static/image/company/pc/visual.ver2_0_2.jpg?a0c08649";